export default __webpack_public_path__ + "static/media/image.lankaloan-com.75c65017.png";